import React, { createContext, useContext, useState, useCallback } from 'react';
import { WalkthroughConfig } from '../components/common/Walkthrough';

interface WalkthroughContextType {
  activeWalkthrough: WalkthroughConfig | null;
  startWalkthrough: (config: WalkthroughConfig) => void;
  stopWalkthrough: () => void;
  isActive: boolean;
}

const WalkthroughContext = createContext<WalkthroughContextType | undefined>(undefined);

export const WalkthroughProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeWalkthrough, setActiveWalkthrough] = useState<WalkthroughConfig | null>(null);

  const startWalkthrough = useCallback((config: WalkthroughConfig) => {
    setActiveWalkthrough(config);
  }, []);

  const stopWalkthrough = useCallback(() => {
    setActiveWalkthrough(null);
  }, []);

  return (
    <WalkthroughContext.Provider
      value={{
        activeWalkthrough,
        startWalkthrough,
        stopWalkthrough,
        isActive: activeWalkthrough !== null,
      }}
    >
      {children}
    </WalkthroughContext.Provider>
  );
};

export const useWalkthrough = () => {
  const context = useContext(WalkthroughContext);
  if (!context) {
    throw new Error('useWalkthrough must be used within WalkthroughProvider');
  }
  return context;
};

